import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  RegistrationRequestService,
  UserRegistrationRequest,
} from 'src/app/Services/RegistrationRequest/registration-request.service';

@Component({
  standalone: false,
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
  supportEmail = 'EWRSfeedback@ontario.ca';
  showSelfRegistrationOption = false;
  registrationRequest: UserRegistrationRequest;

  constructor(
    private router: Router,
    private registrationRequestService: RegistrationRequestService
  ) {}

  ngOnInit(): void {
    this.registrationRequestService.getStatus().subscribe({
      next: (data) => {
        const status = data?.value;
        if (status?.hasPendingRequest && status.request) {
          this.registrationRequest = status.request;
          return;
        }
        this.showSelfRegistrationOption = status?.canSubmitRequest === true;
      },
      error: () => {
        this.registrationRequest = null;
        this.showSelfRegistrationOption = false;
      },
    });
  }

  registerNow(): void {
    this.router.navigateByUrl('/self-register');
  }
}
